import { getLogInAsHeaders, LogInAsHeaderNames } from '@fusion/saas-components-v3'
import type {
  ActivationAddResponse,
  ActivationCancelResponse,
  BillingUpdateResponse,
  DelegoTokenResponse,
  Subscription,
  SubscriptionSKU,
  UserPermission
} from '@/types/subscriptions'
import { GET, POST } from './helpers'

export const getSubscriptionSKUMetadata = async function () {
  return GET<Record<string, SubscriptionSKU>>(
    '/subscriptions/user/skus',
    {},
    {},
    APP_ENV.VITE_APP_SUBS_HOST
  )
}

export const getUserPermissions = async function () {
  return GET<UserPermission[]>(
    '/subscriptions/user/permissions',
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.EMAIL])
    },
    {},
    APP_ENV.VITE_APP_SUBS_HOST
  )
}

export const getUserSubscriptions = async function () {
  return GET<Subscription[]>(
    '/subscriptions/user/',
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.ACCOUNT_ID, LogInAsHeaderNames.SAP_ID])
    },
    {},
    APP_ENV.VITE_APP_SUBS_HOST
  )
}

export const postValidateSubscriptionCode = async function (activationCode: string) {
  return POST<ActivationAddResponse>(
    `/subscriptions/user/activation/add/${activationCode}`,
    JSON.stringify({}),
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.ACCOUNT_ID, LogInAsHeaderNames.SAP_ID])
    },
    {},
    APP_ENV.VITE_APP_SUBS_HOST
  )
}

export const patchCancelSubscription = async function (activationId: string) {
  return POST<ActivationCancelResponse>(
    `/subscriptions/user/activation/cancel/${activationId}`,
    JSON.stringify({}),
    {},
    {},
    APP_ENV.VITE_APP_SUBS_HOST
  )
}

export const postBillingInfoPurchaseOrder = async function (
  activationId: string,
  purchaseOrderReference: string
) {
  const body = { reference: purchaseOrderReference }
  return POST<BillingUpdateResponse>(
    `/subscriptions/user/billing/po/${activationId}`,
    JSON.stringify(body),
    {},
    {},
    APP_ENV.VITE_APP_SUBS_HOST
  )
}

export const postBillingInfoCreditCard = async function (
  activationId: string,
  cardType: string,
  cardToken: string,
  cardExpiry: string,
  cardHolderName: string
) {
  const body = {
    cardType: cardType,
    cardToken: cardToken,
    cardExpiry: cardExpiry,
    cardHolderName: cardHolderName
  }
  return POST<BillingUpdateResponse>(
    `/subscriptions/user/billing/cc/${activationId}`,
    JSON.stringify(body),
    {},
    {},
    APP_ENV.VITE_APP_SUBS_HOST
  )
}

export const getDelegoToken = async function () {
  return GET<DelegoTokenResponse>(
    `/subscriptions/user/delego/token`,
    {},
    {},
    APP_ENV.VITE_APP_SUBS_HOST
  )
}
